<template>
  <div style="padding:0;">
    <iframe src="http://monitor.cnzhonglunnet.com/dashboards/" width="100%" :height="pageHeight" frameborder="0" />
  </div>
</template>

<script>
import $ from 'jquery'
export default {
    data() {
        return {
            pageHeight:800
        }
    },
    methods: {
        
        chartResize(){
            let contentBox = $(".ant-layout-content")
            this.pageHeight = contentBox.height()
        },
    },
    mounted() {
        this.chartResize();
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    }
}
</script>

<style>
.routeView{
  padding: 0 !important;
  margin: 0 !important;
}
</style>
